import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import ChurchesService from '@/services/churches.service';
import type { PagedListRequest, UseChurchesParams } from '@/types';

export const useChurches = ({ churchId, limit = 10, page = 1, search, enabled = true }: UseChurchesParams = {}) => {
  const filters: PagedListRequest = {
    limit,
    page,
    ...(search && { search }),
  };

  return useQuery({
    queryKey: [QUERY_KEYS.CHURCH_BASE_QUERY_KEY, QUERY_KEYS.CHURCHES, churchId, filters],
    queryFn: () => ChurchesService.getChurches(churchId, filters),
    placeholderData: keepPreviousData,
    enabled: enabled && Boolean(churchId),
    staleTime: 1000 * 60 * 5,
  });
};
